import React from 'react';
import { Box, Paper, Skeleton } from '@mui/material';

export const SingleItemLoading = () => {
    return (
        <Box sx={{ width: '100%' }}>
            <Paper sx={{ width: '100%', mb: 2, padding: '10px' }}>
                <Box
                    sx={{
                        display: 'flex',
                        gap: '10px',
                        flexDirection: 'column',
                    }}
                >
                    <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                </Box>
            </Paper>
        </Box>
    );
};
